<app-chat></app-chat>
<router-outlet></router-outlet>